import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M1.5 6A4.5 4.5 0 1 1 6 10.5.75.75 0 0 0 6 12a6 6 0 1 0-4.333-1.85.75.75 0 0 0 1.016.062l.875-.714a.75.75 0 0 0-.95-1.162l-.296.243A4.48 4.48 0 0 1 1.5 6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5.25 6c0 .211.087.402.228.538l1.23 1.23a.75.75 0 0 0 1.06-1.06L6.75 5.688V4.25a.75.75 0 0 0-1.5 0z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }